import { Component } from '@angular/core';

@Component({
  selector: 'app-ppk-downloader-page',
  templateUrl: './ppk-downloader.component.html'
})
export class PpkDownloaderPageComponent {}


